import { courseDocumentsApi } from "api/courseDocumentsApi";
import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";

export const useCourseDocumentStudents = (courseId?: number, templateId?: number, studentsIds?: number[]) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_DOCUMENT_STUDENTS(courseId!, templateId!, studentsIds),
    queryFn: async () => {
      const filter =
        studentsIds && studentsIds.length > 0 ? `students in (${studentsIds.map((x) => `'${x}'`).join(",")})` : "";
      return courseDocumentsApi.getCourseDocumentStudents(courseId!, templateId!, filter);
    },
    enabled: !!courseId && !!templateId,
    refetchOnWindowFocus: false,
  });

  return {
    loading: isLoading,
    data: data?.data ?? null,
    refresh: refetch,
  };
};
